import { Helmet } from 'react-helmet-async';

const DOMAIN = 'https://pixelcraft.fi';
const OG_IMAGE = `${DOMAIN}/og-image.png`;
const SITE_NAME = 'PixelCraft';

const PageSEO = ({ title, description, path = '', ogTitle, ogDescription }) => {
  const canonical = `${DOMAIN}${path}`;
  const resolvedTitle = ogTitle || title;
  const resolvedDesc = ogDescription || description;

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={resolvedTitle} />
      {resolvedDesc && <meta property="og:description" content={resolvedDesc} />}
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      {resolvedDesc && <meta name="twitter:description" content={resolvedDesc} />}
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
};

export default PageSEO;
